const MAX_IMAGE_SIZE_MB = 5;
const MAX_FILE_SIZE_MB = 25;
const STRICT_IMAGE_TYPES = ['image/png', 'image/jpeg'];

export function classifyAttachmentKind(file) {
    if (file.type && file.type.indexOf('image/') === 0) {
        return 'image';
    }
    if (file.type === 'application/pdf') {
        return 'pdf';
    }
    if (file.type && file.type.indexOf('video/') === 0) {
        return 'video';
    }
    return 'file';
}

export function validateAttachment(file) {
    const sizeMb = file.size / 1024 / 1024;

    if (STRICT_IMAGE_TYPES.includes(file.type) && sizeMb > MAX_IMAGE_SIZE_MB) {
        return __('Your file is too big to submit. Maximum allowed size for images is 5MB');
    }
    if (sizeMb > MAX_FILE_SIZE_MB) {
        return __('Your file is too big to submit.We recommend keeping videos under 30 seconds in length. Maximum allowed size is 25MB');
    }
    return null;
}

// previewUrl must be revoked by the caller on remove.
export function buildAttachment(file) {
    const kind = classifyAttachmentKind(file);

    return {
        key: `${file.name}-${file.size}-${file.lastModified}`,
        file,
        name: file.name,
        kind,
        previewUrl: kind === 'image' ? URL.createObjectURL(file) : null,
    };
}

export function showAttachmentError(message) {
    const $ = window.jQuery;
    const modal = $ ? $('#general-error-modal') : null;

    if (modal && modal.length) {
        modal.find('.modal-body').text(message);
        modal.modal();
        return;
    }

    window.alert(message);
}
